/*eslint-disable */
import appFooter from '../../components/footer/index';
import toast from '../../services/toast';
var $ = window.jQuery = require('jquery');
export default {
  name: 'password-reset',
  components: {
    'app-footer': appFooter,
  },
  props: [],
  data() {
    return {
      password: '',
      confirm_password: '',
      id: '',
      submitted: false
    }
  },
  computed: {

  },
  mounted() {
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
  },
  methods: {
    validateBeforeResetPasswordSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            password: this.password,
            confirm_password: this.confirm_password
          }
          this.$store.dispatch('resetPasswordConfirmFun', {
              data: {
                data: data,
                id: this.$route.params.reset_key
              }
            })
            .then((response) => {
              if (response.status == 200) {
                toast.success(response.data.msg);
                this.password = ''
                this.confirm_password = ''
                this.$validator.reset();
              }
            }).catch((err) => {
              this.password = ''
              this.confirm_password = ''
              this.$validator.reset();
              toast.error('Link is expired');
            })
          return
        }
      })
    }
  },
  beforeCreate: function() {
    $('body').addClass('public-routes');
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('public-routes');
    next();
  },
}